import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-sans font-bold break-normal text-gray-700 px-2 pb-2" }, " 管理者 ", -1)
const _hoisted_2 = {
  key: 0,
  class: "p-2 mt-2 rounded shadow bg-white"
}
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "text-xl font-bold" }
const _hoisted_5 = { class: "p-2 mt-2 rounded shadow bg-white" }
const _hoisted_6 = { class: "p-6" }
const _hoisted_7 = { class: "mb-2 last:mb-0" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("名前"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_11 = { class: "text-xs text-pink-600" }
const _hoisted_12 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2 mt-2" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("名前(カナ)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_15 = { class: "text-xs text-pink-600" }
const _hoisted_16 = {
  key: 0,
  class: "mb-2 last:mb-0"
}
const _hoisted_17 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("メールアドレス"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_20 = { class: "text-xs text-pink-600" }
const _hoisted_21 = { class: "text-right col-span-full mt-4" }
const _hoisted_22 = ["onClick"]

import { useField, useForm } from "vee-validate";
import * as yup from "yup";

import Salon from "@/models/Salon";
import Administrator from "@/models/Administrator";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdministratorEdit',
  setup(__props) {

// import { defineComponent, Ref } from "vue";
const store = useStore();
const route = useRoute();
const router = useRouter();

// interface AdministratorEditState {
//   salon: Salon;
//   administrator: Administrator | null;
//   for_salon: boolean;

//   name: Ref<string>;
//   name_error: Ref<string>;

//   kana: Ref<string>;
//   kana_error: Ref<string>;

//   email: Ref<string>;
//   email_error: Ref<string>;
// }

// export default defineComponent({
//   components: {
//     // Autocomplete,
//   },

//   data() {
const formSchema = yup.object({
  name: yup.string().required("必須項目です"),
  kana: yup.string().kana().required("必須項目です"),
  email: yup.string().email().required("必須項目です"),
});

useForm({ validationSchema: formSchema });

const name_field = useField<string>("name");
const kana_field = useField<string>("kana");
const email_field = useField<string>("email");

//     return {
//       // is_loading: false,

//       showing_suggest: false,

const salon = ref<Salon>({} as Salon);
const administrator = ref<Administrator | null>(null);
const for_salon = ref<boolean>(true);

const name = name_field.value;
const name_error = name_field.errorMessage;

const kana = kana_field.value;
const kana_error = kana_field.errorMessage;

const email = email_field.value;
const email_error = email_field.errorMessage;
//     } as AdministratorEditState;
//   },

//   mounted() {
//     refresh();
//   },

onMounted(() => {
  refresh();
});

//   methods: {
const refresh = () => {
  if (store.state.is_loading) {
    return;
  }

  const pathSalonId = route.params.salon_id as string | null;
  const userSalonId = store.state.salon_id as string | null;
  const id = route.params.administrator_id as string | null;

  console.log(pathSalonId);
  console.log(userSalonId);

  const salonId = pathSalonId || (userSalonId as string);

  for_salon.value = !!userSalonId;

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      salon.value = await Salon.get(salonId);
      if (id) {
        administrator.value = await Administrator.get(id);

        name.value = administrator.value.name;
        kana.value = administrator.value.kana;
        email.value = administrator.value.email;
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const validate = async (): Promise<boolean> => {
  await name_field.validate();
  await kana_field.validate();
  await email_field.validate();

  return !name_error.value && !kana_error.value && !email_error.value;
};

const onSave = () => {
  if (store.state.is_loading) {
    return;
  }

  const pathSalonId = route.params.salon_id as string | null;
  const userSalonId = store.state.salon_id as string | null;

  const salon_id = pathSalonId || (userSalonId as string);

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validate();
      if (!valid) {
        return;
      }

      if (!administrator.value) {
        await Administrator.registerSalon(
          salon_id,
          name.value,
          kana.value,
          email.value
        );
      } else {
        await Administrator.update(
          administrator.value.id,
          name.value,
          kana.value
        );
      }

      if (for_salon.value) {
        router.push(`/administrators`);
      } else {
        router.push(`/salons/${salon_id}`);
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};
//   },
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!for_salon.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, " 【" + _toDisplayString(salon.value.id) + "】" + _toDisplayString(salon.value.name) + " (" + _toDisplayString(salon.value.kana) + ") ", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(name_error) }]),
                placeholder: "名前",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(name)]
              ]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(name_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(kana_error) }]),
                placeholder: "カナ",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(kana) ? (kana).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(kana)]
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(kana_error)), 1)
            ])
          ])
        ]),
        (!administrator.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(email_error) }]),
                    placeholder: "Eメール",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(email)]
                  ]),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(email_error)), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        class: "shadow bg-yellow-700 hover:bg-yellow-500 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded",
        type: "button",
        onClick: _withModifiers(onSave, ["prevent"])
      }, " 登録 ", 8, _hoisted_22)
    ])
  ], 64))
}
}

})